/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { PromotionAwardRequestDto } from '../models';
// @ts-ignore
import type { PromotionAwardResponseDto } from '../models';
/**
 * PROMOTIONApi - axios parameter creator
 * @export
 */
export const PROMOTIONApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Награждения пользователя за действия
         * @param {PromotionAwardRequestDto} promotionAwardRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promotionControllerPromotionAward: async (promotionAwardRequestDto: PromotionAwardRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promotionAwardRequestDto' is not null or undefined
            assertParamExists('promotionControllerPromotionAward', 'promotionAwardRequestDto', promotionAwardRequestDto)
            const localVarPath = `/promotion/promotionAward`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promotionAwardRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Награждение за подписку на телеграм канал
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promotionControllerPromotionAwardTelegram: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/promotion/promotionAwardTelegram`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PROMOTIONApi - functional programming interface
 * @export
 */
export const PROMOTIONApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PROMOTIONApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Награждения пользователя за действия
         * @param {PromotionAwardRequestDto} promotionAwardRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promotionControllerPromotionAward(promotionAwardRequestDto: PromotionAwardRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromotionAwardResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promotionControllerPromotionAward(promotionAwardRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PROMOTIONApi.promotionControllerPromotionAward']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Награждение за подписку на телеграм канал
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promotionControllerPromotionAwardTelegram(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromotionAwardResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promotionControllerPromotionAwardTelegram(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PROMOTIONApi.promotionControllerPromotionAwardTelegram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PROMOTIONApi - factory interface
 * @export
 */
export const PROMOTIONApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PROMOTIONApiFp(configuration)
    return {
        /**
         * 
         * @summary Награждения пользователя за действия
         * @param {PromotionAwardRequestDto} promotionAwardRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promotionControllerPromotionAward(promotionAwardRequestDto: PromotionAwardRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PromotionAwardResponseDto> {
            return localVarFp.promotionControllerPromotionAward(promotionAwardRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Награждение за подписку на телеграм канал
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promotionControllerPromotionAwardTelegram(options?: RawAxiosRequestConfig): AxiosPromise<PromotionAwardResponseDto> {
            return localVarFp.promotionControllerPromotionAwardTelegram(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PROMOTIONApi - object-oriented interface
 * @export
 * @class PROMOTIONApi
 * @extends {BaseAPI}
 */
export class PROMOTIONApi extends BaseAPI {
    /**
     * 
     * @summary Награждения пользователя за действия
     * @param {PromotionAwardRequestDto} promotionAwardRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PROMOTIONApi
     */
    public promotionControllerPromotionAward(promotionAwardRequestDto: PromotionAwardRequestDto, options?: RawAxiosRequestConfig) {
        return PROMOTIONApiFp(this.configuration).promotionControllerPromotionAward(promotionAwardRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Награждение за подписку на телеграм канал
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PROMOTIONApi
     */
    public promotionControllerPromotionAwardTelegram(options?: RawAxiosRequestConfig) {
        return PROMOTIONApiFp(this.configuration).promotionControllerPromotionAwardTelegram(options).then((request) => request(this.axios, this.basePath));
    }
}

